// extracted by mini-css-extract-plugin
export default {"modal":"VendorsListModal_modal__K1gSG","main":"VendorsListModal_main__ZRhWZ","search":"VendorsListModal_search__Hc0aK","container":"VendorsListModal_container__GKXcn"};